import type { IdentityMeResponse, UserResponse } from '../generated/models';

export type MockCaller = Pick<IdentityMeResponse, 'userId' | 'tier' | 'sspId' | 'ssuId'>;

const emptyId = '00000000-0000-0000-0000-000000000000';

/** Mirrors identity.users' tenant and SELECT-only self policies before query filters. */
export function canReadUser(caller: MockCaller, user: UserResponse): boolean {
  if (user.userId === caller.userId) return true;
  if (user.ssuId && !user.sspId) return false;
  if (caller.tier === 'sira') return true;
  if (!caller.sspId || caller.sspId === emptyId || user.sspId !== caller.sspId) return false;
  if (caller.tier === 'ssp') return true;
  return (
    ['ssu', 'operator', 'auditor'].includes(caller.tier ?? '') &&
    !!caller.ssuId &&
    caller.ssuId !== emptyId &&
    (!user.ssuId || user.ssuId === caller.ssuId)
  );
}
